<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="88vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row>
                  <v-col cols="4">
                    <v-card height="35vh" class="detail-115-dashboard-card" elevation="0"></v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card height="35vh" class="detail-115-dashboard-card" elevation="0"></v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card height="35vh" class="detail-115-dashboard-card" elevation="0"></v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card height="45vh" class="detail-115-dashboard-card" elevation="0"></v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card height="45vh" class="detail-115-dashboard-card" elevation="0"></v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {};
</script>
<style scoped>
  .main-dashboard-115-card {
    border-radius: 10px !important;
    border: 1px solid #2edf93 !important;
  }
  .body-card {
    overflow-y: auto;
  }
  .detail-115-dashboard-card {
    background: #ecfff7 !important;
    border-radius: 15px !important;
  }
</style>
